require("./chunk/_polyfills.js");

import { viewport, debounce } from "./chunk/_utils.js";
import "./chunk/offcanvas.js";
import "./chunk/url";
import "./chunk/cursor";
import "./chunk/typeit";
import "./chunk/matomo";
import "./chunk/scroll_smooth";



/**
 * scriptStateHandler
 */
import scrollspy from "./chunk/scroll_spy.js";
import scroll_video from "./chunk/scroll_video";

const scrollspyElements = document.querySelectorAll("section[id]");

let scrollspyHandler = () => {
  scroll_video();
  scrollspy(scrollspyElements);
};

/**
 * throtteld restart of scriptStateHandler()
 * on viewport changes
 */
// let debounceAnimationScripts = debounce(
//   scrollspyHandler(),
//   300,
//   false
// );
// window.addEventListener("resize", debounceAnimationScripts);
// window.addEventListener("orientationchange", debounceAnimationScripts);

if (document.readyState == "complete") {
  scrollspyHandler();
  // docReady()
} else {
  document.onreadystatechange = function () {
    scrollspyHandler();
    // docReady()
  };
}

// let docReady = () => {
//   document.body.classList.add('ready')
// }
document.body.classList.add("ready");






/**
 * AV-Vertrag
 * pdf-lib
 * https://github.com/Hopding/pdf-lib#documentation
 */


const isPDF = document.querySelector('#dpa');
if (isPDF) {
  require.ensure([], (require) => { 
    require('./pdf.js'); 
  })
}


